import { paths } from "@/paths";
import { ROLES } from "@typings/entities/users/enums";
import LoadingUser from "@commons/Loading/LoadingUser";
import { useUser } from "@hooks/useUser";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

export interface AuthGuardProps {
  children: React.ReactNode;
  roles?: (typeof ROLES)[keyof typeof ROLES][];
}

export function AuthGuard({ children, roles }: AuthGuardProps) {
  const { user, role, isCheckingUser } = useUser();

  const hasPermission = !roles || (role && roles.includes(role));

  if (isCheckingUser) return <LoadingUser />;

  if (!user || !role) return <Navigate to={paths.auth} replace />;

  if (!hasPermission) {
    toast.error("Você não tem permissão para acessar essa página.", {
      toastId: "permission-denied",
    });
    return <Navigate to={paths.home} replace />;
  }

  return <>{children}</>;
}
